import $ from 'jquery';

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

import bodyScrollClass from './bodyScrollClass';

import InpageNavigation from './InpageNavigation';
import PageScrollIndicator from './PageScrollIndicator';

import MobileMainNav from './MobileMainNav';

import navigationToggle from './navigationToggle';
import accordion from './accordion';
import TextWithImageCarousel from './TextWithImageCarousel';
import IntroCarousel from './IntroCarousel';
import ImageCarousel from './ImageCarousel';
import NewsList from './NewsList';

window.$ = $;
window.jQuery = $;



document.addEventListener('DOMContentLoaded', event => {
  bodyScrollClass();

  navigationToggle();
  accordion();

  $('.vertical-navigation').each((index, item) => {
    new InpageNavigation($(item));
  });

  $('.page-scroll-indicator').each((index, item) => {
    new PageScrollIndicator($(item));
  });


  $('.mobile-navigation .main-nav').each((index, item) => {
    new MobileMainNav($(item));
  });

  $('.text-with-image-carousel').each((index, item) => {
    new TextWithImageCarousel($(item));
  });

  $('.intro-carousel').each((index, item) => {
    new IntroCarousel($(item));
  });

  $('.image-carousel').each((index, item) => {
    new ImageCarousel($(item));
  });

  $('.news-list').each((index, item) => {
    new NewsList($(item));
  });

  AOS.init({
    duration: 1000,
    once: true,
    // offset: 50
  });
});
